import type { IOsasReferralData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralSchema';
import type { ICheckBoxGroupWithTextFieldProps } from '@frontend/components/fields/CheckBoxGroup';
import type { ValidationErrors } from '@frontend/utils';
import { CheckBoxGroupWithTextField } from '@frontend/components/fields/CheckBoxGroup';

interface IImportantComplaintsFormGroupProps {
    data: IOsasReferralData;
    errors: ValidationErrors;
    isRequired: boolean;
    onChange: (data: Partial<IOsasReferralData>, validateKeys?: string | string[] | undefined) => void;
}

export function ImportantComplaintsFormGroup(props: IImportantComplaintsFormGroupProps) {
    const { data, errors, isRequired, onChange } = props;
    const importantComplaintOptions: ICheckBoxGroupWithTextFieldProps['checkboxOptions'] = [
        {
            checked: data.importantComplaints.sleepiness || false,
            label: 'Slaperigheid',
            onChange: (value: boolean) => handleChangeImportantComplaintOptions('sleepiness', value),
        },
        {
            checked: data.importantComplaints.tiredness || false,
            label: 'Vermoeidheid',
            onChange: (value: boolean) => handleChangeImportantComplaintOptions('tiredness', value),
        },
        {
            checked: data.importantComplaints.breathStops || false,
            label: 'Ademstops',
            onChange: (value: boolean) => handleChangeImportantComplaintOptions('breathStops', value),
        },
        {
            checked: data.importantComplaints.snoring || false,
            label: 'Snurken',
            onChange: (value: boolean) => handleChangeImportantComplaintOptions('snoring', value),
        },
        {
            label: 'Anders',
            onChange: (value: string | null) => handleChangeImportantComplaintOptions('other', value),
            value: data.importantComplaints.other,
        },
    ];

    return (
        <CheckBoxGroupWithTextField
            checkboxOptions={importantComplaintOptions}
            error={errors.get('importantComplaints') || errors.get('importantComplaints.other')}
            hasErrors={errors.has('importantComplaints') || errors.has('importantComplaints.other')}
            isRequired={isRequired}
            label="Belangrijkste klachten"
        />
    );

    function handleChangeImportantComplaintOptions<T extends keyof IOsasReferralData['importantComplaints']>(
        key: T,
        value: IOsasReferralData['importantComplaints'][T]
    ) {
        onChange({ importantComplaints: { ...data.importantComplaints, [key]: value } }, [
            'importantComplaints',
            `importantComplaints.${key}`,
        ]);
    }
}
